import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel } from 'src/app/models/address.model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-capture-address',
  templateUrl: './capture-address.component.html',
  styleUrls: ['./capture-address.component.scss'],
})
export class CaptureAddressComponent implements OnInit {

  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() key: string;
  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter<AddressModel>();

  address: AddressModel;
  loading = false;

  constructor(
    private api: ApiService,
  ) { }

  ngOnInit() {
    if (this.quickQuote.answersObject['AddressStreet']) {
      this.address = new AddressModel({
        buildingNumber: this.quickQuote.answersObject['AddressBuildingNumber'],
        subBuilding: this.quickQuote.answersObject['AddressSubBuilding'],
        buildingName: this.quickQuote.answersObject['AddressBuildingName'],
        street: this.quickQuote.answersObject['AddressStreet'],
        city: this.quickQuote.answersObject['AddressCity'],
        county: this.quickQuote.answersObject['AddressCounty'],
        country: this.quickQuote.answersObject['AddressCountry'],
        postCode: this.quickQuote.answersObject['AddressPostCode']
      });
    }
  }

  async proceed() {
    this.loading = true;

    try {
      // this.address.country = this.selectedCountry;
      const answers = await this.api.saveAddress(this.key, this.address);

      for (let ans of answers) // keep quick quote model up to date with answers
        this.quickQuote.saveAnswer(ans.key, ans.value);

      this.continue.emit(this.address); //FullQuote.NotEligible
    } finally {
      this.loading = false;
    }
  }
}
